import script from "./AskAdmin.vue?vue&type=script&lang=ts&setup=true"
export * from "./AskAdmin.vue?vue&type=script&lang=ts&setup=true"

import "./AskAdmin.vue?vue&type=style&index=0&id=3eb3a377&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb3a377"]])

export default __exports__